<template>
  <div class="PageTitle"
    :class="pageTitleClasses">

    <div class="PageTitle-lock">

      <icon class="PageTitle-lockIcon"
        v-if="lock"
        name="lock"
        width="18px"
        height="18px" />

    </div>

    <h1 class="PageTitle-title"
      v-html="resolvedTitle">
    </h1>

  </div>
</template>

<script>
export default {
  name: 'PageTitle',

  props: {
    /**
     * Title string override
     */
    title: {
      type: String
    },

    /**
     * Show lock icon before title
     */
    lock: {
      type: Boolean,
      default: false
    },

    /**
     * Whether to show titles at 18/24
     * - Useful for client pages where client names are extra long.
     * - Normal page titles tend to be short.
     */
    small: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    /**
     * The current page object
     * @return {Object}
     */
    currentPage () { return this.$store.state.currentPage },

    /**
     * Classes for the page title
     * @return {Object}
     */
    pageTitleClasses () {
      return {
        'PageTitle--showLock': this.lock,
        'PageTitle--isSmall': this.small
      }
    },

    /**
     * The title text
     * @return {String}
     */
    resolvedTitle () {
      if (this.title) return this.title
      if (!this.currentPage.attributes) return
      return this.currentPage.attributes.title
    }
  }
}
</script>

<style>
@import 'properties';

.PageTitle {
  display: flex;
  align-items: baseline;
}

.PageTitle--showLock {
  align-items: center;
}

.PageTitle-lockIcon {
  position: relative;
  top: 1px;
  margin-right: var(--unit-05);
}

.PageTitle-lock svg {
  fill: var(--c-grey-lt) !important;
}

.PageTitle-title {
  /* Leading compensation */
  margin-bottom: -5px;

  font-family: var(--font-family-sans);
  font-size: 24px;
  line-height: 24px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

.PageTitle--isSmall .PageTitle-title {
  font-size: 18px;

  @media (min-width: 600px) {
    font-size: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// PageTitle.vue?322c2f79